define('taoRevision/controller/routes',[],function(){
    return {
        'History' : {
            'actions' : {
                'index' : 'controller/history/index',
            }
        }
    };
});

